import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No. Esta formación está pensada tanto para principiantes como para profesionales. Todo se explica paso a paso, desde lo más básico hasta el procedimiento completo, para que aprendas de forma segura desde cero.'
}, {
  question: '¿Es solo teoría o también práctica real?',
  answer: 'Es una formación 100% práctica. Vas a ver procedimientos reales, técnicas reales y resultados reales a través de más de 30 lecciones en video, además de material profesional descargable.'
}, {
  question: '¿Incluye BB Lips y Hydra Lips?',
  answer: 'Sí. Aprendés Hydra Gloss Lips + BB Lips Hidratación, incluyendo uso de productos, manejo del Dermapen, selección de color, profundidad, presión y cuidados posteriores.'
}, {
  question: '¿Puedo usar cualquier Dermapen?',
  answer: 'Sí. El curso te enseña cómo calibrar y adaptar distintos Dermapen, elegir la aguja correcta y trabajar de forma segura y profesional.'
}, {
  question: '¿Cuánto tiempo tengo acceso al curso?',
  answer: 'Tenés acceso de por vida. Podés ver las clases las veces que quieras, a tu ritmo y desde cualquier dispositivo.'
}, {
  question: '¿Es un solo pago?',
  answer: 'Sí. Pagás una sola vez. No hay suscripciones ni costos ocultos.'
}, {
  question: '¿Qué pasa si no me gusta el curso?',
  answer: 'Estás protegida. Tenés una garantía de 7 días. Si sentís que no es para vos, solicitás el reembolso y te devolvemos el 100% del dinero, sin preguntas.'
}, {
  question: '¿Puedo empezar a ofrecer el servicio después del curso?',
  answer: 'Sí. La formación está diseñada para que termines segura, preparada y con confianza para empezar a ofrecer el servicio luego de practicar.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-16 px-4 bg-gradient-to-b from-white to-[#FDFBF7]" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <div className="text-center mb-16 space-y-4" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block" data-id="element-35">
            <span className="text-[#D4AF7A] text-xs font-medium tracking-[0.2em] uppercase" data-id="element-36">
              Preguntas Frecuentes
            </span>
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-semibold text-[#3D3028]" data-id="element-37">
            Todo lo que necesitás saber
          </h2>
          <p className="text-base text-[#3D3028]/60 max-w-xl mx-auto leading-relaxed" data-id="element-38">
            Resolvemos las dudas más comunes sobre el Master
          </p>
        </div>

        <div className="space-y-3" data-id="element-39">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="group" data-id="element-40">
              <button onClick={() => toggleQuestion(index)} className={`w-full text-left transition-all duration-300 ${openIndex === index ? 'bg-white shadow-md' : 'bg-white/50 hover:bg-white hover:shadow-sm'} rounded-2xl`} data-id="element-41">
                <div className="px-6 md:px-8 py-6 flex items-start justify-between gap-4" data-id="element-42">
                  <span className={`font-medium text-base md:text-lg leading-relaxed transition-colors ${openIndex === index ? 'text-[#E5A5A0]' : 'text-[#3D3028] group-hover:text-[#E5A5A0]'}`} data-id="element-43">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="flex-shrink-0 mt-1" data-id="element-44">
                    <svg className={`w-5 h-5 transition-colors ${openIndex === index ? 'text-[#E5A5A0]' : 'text-[#3D3028]/40 group-hover:text-[#E5A5A0]'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-45">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-46" />
                    </svg>
                  </motion.div>
                </div>

                <AnimatePresence data-id="element-47">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-48">
                      <div className="px-6 md:px-8 pb-6 pt-2" data-id="element-49">
                        <div className="border-t border-[#D4C4B0]/20 pt-4" data-id="element-50">
                          <p className="text-[#3D3028]/70 text-base leading-relaxed" data-id="element-51">
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </button>
            </motion.div>)}
        </div>

        {/* Elegant CTA after FAQ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-52">
          <div className="relative" data-id="element-53">
            <div className="absolute inset-0 bg-gradient-to-r from-[#E5A5A0]/5 via-[#E5A5A0]/10 to-[#E5A5A0]/5 rounded-3xl blur-xl" data-id="element-54" />
            <div className="relative bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-[#E5A5A0]/10" data-id="element-55">
              <p className="text-[#3D3028] font-medium text-lg mb-3" data-id="element-56">
                ¿Tenés otra pregunta?
              </p>
              <p className="text-[#3D3028]/60 text-base leading-relaxed max-w-lg mx-auto" data-id="element-57">
                Todas tus dudas se resolverán dentro del curso. Además, tenés 7
                días de garantía para probarlo sin riesgo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}